import Konva from 'konva'

export default {
  methods: {
    attachTransformer () {
      if (this.transformShape) {
        let shape = this.transformShape
        let tr = new Konva.Transformer({
          rotateEnabled: false,
          lineEnabled: false
        })

        this.drawLayer.add(tr)
        tr.attachTo(shape)
        this.drawLayer.draw()
      }
    },

    destroyTransformer () {
      if (this.transformShape) {
        this.transformShape = null
        this.drawLayer.find('Transformer').destroy()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/konvaTransformer.js